import chroma from "chroma-js";
import type { Theme } from "../types/Theme";
import * as Mixins from "./Mixins";

function hexKey(color: string | undefined): string | null {
    if (!color) {
        return null;
    }
    try {
        return chroma(color).alpha(1).hex("rgb").toLowerCase();
    } catch {
        return null;
    }
}

/** Page validation banner background: explicit background, then API typo key, then legacy solid ErrorColor. */
export function resolveErrorBannerBackground(theme: Theme): string {
    return theme.ErrorBackgroundColor ?? theme.ErrorBackgroudColor ?? theme.ErrorColor;
}

/**
 * When the banner is the legacy solid ErrorColor bar, use high-contrast foreground on that fill.
 * When a separate light (or non-error) background is used, message and icon use ErrorColor.
 */
export function resolveErrorBannerForeground(theme: Theme): string {
    const bg = resolveErrorBannerBackground(theme);
    const bgKey = hexKey(bg);
    const errKey = hexKey(theme.ErrorColor);
    if (bgKey != null && errKey != null && bgKey === errKey) {
        return Mixins.foregroundColor(theme, theme.ErrorColor);
    }
    return theme.ErrorColor;
}

/**
 * Outline for the light-banner variant; omitted for legacy solid bar (same fill as ErrorColor).
 */
export function resolveErrorBannerBorder(theme: Theme): string | undefined {
    const bg = resolveErrorBannerBackground(theme);
    const bgKey = hexKey(bg);
    const errKey = hexKey(theme.ErrorColor);
    if (bgKey != null && errKey != null && bgKey === errKey) {
        return undefined;
    }
    const w = theme.BorderWidth ?? 1;
    return `${w}px solid ${theme.ErrorColor}`;
}

/** Vertical gap (px) between per-question validation row and question title/text; modern theme only. */
export function resolveQuestionErrorToLabelGap(theme: Theme): number | undefined {
    return theme.UseModernTheme ? 8 : undefined;
}
